export const LOGQS_ORIGIN = "https://logqs.com/";

export const NOTEBOOK_HELP_LINK =
  "https://colab.research.google.com/drive/1RevEpY40lj-jGjl8WZRvzxxKXRC4NtSp#scrollTo=e9YbbSlcJ7ua";
